import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
const products = [{
  name: "Phenolic legend plates",
  url: "/products/phenolic-legend-plates/"
}, {
  name: "30mm legend plates",
  url: "/products/phenolic-legend-plates/30mm/"
}, {
  name: "Engraved nameplates",
  url: "/products/engraved-nameplates/"
}, {
  name: "Panel nameplates",
  url: "/products/engraved-nameplates/panel-nameplates/"
}, {
  name: "Electrical panel schedules",
  url: "/products/electrical-panel-schedules/"
}, {
  name: "MIL-SPEC phenolic",
  url: "/products/mil-spec-phenolic/"
}];
export default function WhereUsed() {
  return;
}